import {
  getAccessibilitySeasonBySlug,
  getPrivateSeasonBySlug,
  getSeasonBySlug
} from "./chunk-EW3JJYGP.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/seasons/detail.ts
import { useQuery } from "@tanstack/react-query";
var useGetSeason = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["useGetSeason", props],
    queryFn: () => {
      if (props.private) {
        return getPrivateSeasonBySlug(props);
      }
      return getSeasonBySlug(props);
    }
  }, options));
};
var useGetAccessibilitySeason = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getAccessibilitySeasonBySlug", props],
    queryFn: () => {
      return getAccessibilitySeasonBySlug(props);
    }
  }, options));
};

export {
  useGetSeason,
  useGetAccessibilitySeason
};
//# sourceMappingURL=chunk-MHZ4XSJZ.mjs.map